import { Container, Form, ScifiPanel, SectionTitle } from '@sloyd/ui';
import { forms } from '../../_definitions/forms';
import { Groups, Wrapper } from './ContentSettings.style';

export type ContentSettingsProps = {
  settings: ISettings;
  callbacks: {
    onChange: (_change: Json, allData: Json) => void;
  };
};

export function ContentSettings(props: ContentSettingsProps) {
  const { settings, callbacks } = props;

  return (
    <Wrapper className='ContentSettings-wrapper' data-testid='ContentSettings-wrapper'>
      <Container size='xs'>
        <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='Settings'>
          Tweak your <strong>settings</strong> here.
        </SectionTitle>
        <Groups>
          <ScifiPanel header='General'>
            <Form
              config={forms.settings as any}
              allOptions={{}}
              data={settings}
              onChange={callbacks.onChange}
            />
          </ScifiPanel>
        </Groups>
      </Container>
    </Wrapper>
  );
}

export default ContentSettings;
